import { type FC, useEffect } from 'react';
import { Layout } from '../../components/layout/Layout';
import { Redirect } from '../../components/redirect/Redirect';
import { useGTM } from '../../hooks/gtm/useGTM';
import { CategorySearchLazy } from '../search/CategorySearchLazy';
import { AddCategorySeo } from './AddCategorySeo';
import { isCategoryInfo } from './api/getContentData';
import { ShowBrandLanding } from './templates/ShowBrandLanding';
import { ShowCatLanding } from './templates/ShowCatLanding';
import { ShowCmsLanding } from './templates/ShowCmsLanding';
import type { CategoryInfo } from './api/getContentData';

interface ShowCategoryPageProps {
    categoryInfo?: CategoryInfo;
}

const ShowCategoryPage: FC<ShowCategoryPageProps> = ({ categoryInfo }) => {
    const { updatePageData, onCategoryPageView } = useGTM();

    const isCategorySearch =
        (isCategoryInfo(categoryInfo) &&
            categoryInfo?.response?.category?.c_template ===
                'rendering/category/categoryproducthits') ||
        !categoryInfo?.response?.category?.c_template;

    const category = categoryInfo?.response?.category;

    useEffect(
        () => () => {
            updatePageData({
                isPLP: false,
                isCategoryPage: false,
                category: undefined,
                search: undefined,
            });
        },
        [],
    );

    useEffect(() => {
        updatePageData({
            isPLP: isCategorySearch,
            isCategoryPage: !isCategorySearch,
        });
    }, [updatePageData, isCategorySearch]);

    useEffect(() => {
        if (!isCategorySearch && category && category.id !== window.pageData?.category?.id) {
            onCategoryPageView(category);
        }
    }, [category]);

    if (
        categoryInfo?.response?.category?.c_template ===
        'rendering/category/brandcategorylandingpage'
    ) {
        if (categoryInfo?.response.urlMapping?.destinationUrl) {
            return <Redirect to={categoryInfo?.response.urlMapping?.destinationUrl} type="sg" />;
        }

        return (
            <AddCategorySeo categoryInfo={categoryInfo}>
                <ShowBrandLanding categoryInfo={categoryInfo} />
            </AddCategorySeo>
        );
    }

    if (categoryInfo?.response?.category?.c_template === 'rendering/category/catlanding') {
        if (categoryInfo?.response.urlMapping?.destinationUrl) {
            return <Redirect to={categoryInfo?.response.urlMapping?.destinationUrl} type="sg" />;
        }
        return (
            <AddCategorySeo categoryInfo={categoryInfo}>
                <ShowCatLanding categoryInfo={categoryInfo} />
            </AddCategorySeo>
        );
    }

    if (categoryInfo?.response?.category?.c_template === 'rendering/category/cmslanding') {
        if (categoryInfo?.response.urlMapping?.destinationUrl) {
            return <Redirect to={categoryInfo?.response.urlMapping?.destinationUrl} type="sg" />;
        }
        return (
            <AddCategorySeo categoryInfo={categoryInfo}>
                <ShowCmsLanding categoryInfo={categoryInfo} />
            </AddCategorySeo>
        );
    }

    if (isCategorySearch) {
        return <CategorySearchLazy categoryInfo={categoryInfo} />;
    }

    return (
        <Layout>
            <h1>Not implemented category template</h1>
        </Layout>
    );
};

ShowCategoryPage.defaultProps = {
    categoryInfo: undefined,
};

export { ShowCategoryPage };
